import { render, staticRenderFns } from "./CartaoPrincipal.vue?vue&type=template&id=9c832e40&scoped=true"
import script from "./CartaoPrincipal.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoPrincipal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoPrincipal.vue?vue&type=style&index=0&id=9c832e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c832e40",
  null
  
)

export default component.exports